import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { prevTaskService } from '../../../../services/prev-task.service';
import { AgGridAngular } from 'ag-grid-angular';
import * as moment from 'moment';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { DatePickerCellEditorComponent } from '../date-picker-cell-editor.component';
import { DatePickerFromCellEditorComponent } from '../date-picker-from-cell-editor.component';
import { TechnicianDropdownCellEditorComponent } from '../technician-dropdown-cell-editor/technician-dropdown-cell-editor.component';
import { BaseApi } from 'src/backend/api/base-api';
import { from } from 'rxjs';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reschedule-task-dialog',
  templateUrl: './reschedule-task-dialog.component.html',
  styleUrls: ['./reschedule-task-dialog.component.scss'],
  providers: [DatePipe]
})
export class RescheduleTaskDialogComponent implements OnInit {
  @ViewChild('agGrid') agGrid!: AgGridAngular;
  initialRowData: any[] = [];
  get isRescheduleDisabled(): boolean {
    return this.rowData.some(task => !task.rescheduledFromDate || !task.rescheduledToDate);
  }
  selectedTechnicians: string[] = [];
  technicianFilter: string = '';
  filteredTechnicianList: any[] = [];
  technicianSearch: string = '';
  originalTechnicianMap: { [taskId: number]: string } = {};
  tasks: any[] = [];
  technicianList: any[] = [];
  spinnerText: string = '';
  columnDefs: any[];
  gridApi: any;
  ToTaskDate: any;
  FromTaskDate: any;
  gridColumnApi: any;
  minDate: Date = new Date();;
  toTaskMinDate: Date = new Date();;
  rowData: any[] = [];
  plantSession: any;
  groupSession: any;
  userSession: any;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  gridOptions: any = {
    defaultColDef: {
      flex: 1,
      sortable: false,  // Disable sorting for all columns
      resizable: true,
      wrapText: true,
      filter: false,    // Disable filtering for all columns
    },
    suppressCellSelection: true,
    pagination: true,
    paginationPageSize: 5,
    paginationPageSizeSelector: [5, 10, 20],
    suppressHorizontalScroll: false,

    onFirstDataRendered: (params: any) => {
      params.columnApi.autoSizeAllColumns();
    },
    onGridSizeChanged: (params: any) => {
      params.columnApi.autoSizeAllColumns();
    },
    onCellValueChanged: (event: any) => this.onCellValueChanged(event),
  };
  availableDateList: any[] = [];
  monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  isAccess = ApplicationPermission.SCHEDULE_TASK_ACCESS;
  isWrite = ApplicationPermission.SCHEDULE_TASK_CREATE;
  largestDate: any = '';

  constructor(
    public dialogRef: MatDialogRef<RescheduleTaskDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private prevTaskService: prevTaskService,
    private baseApi: BaseApi,
    public translater: TranslaterService,
    public translate: TranslateService,
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
    console.log('Constructor: Dialog data=', data);
    this.tasks = data.task || [];
    this.technicianList = data.technicianList || [];

    this.columnDefs = [
      {
        headerName: 'Machine',
        field: 'units.puDesc',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Component',
        field: 'component.componentName',
        headerValueGetter: this.localizeHeader.bind(this),
      },

      {
        headerName: 'Task',
        field: 'Description',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'TaskID',
        field: 'ID',
        hide: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Activity Type',
        field: 'WOType.Name',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Frequency',
        field: 'Frequency.Name',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Schedule',
        field: 'TaskStatus',
        headerValueGetter: this.localizeHeader.bind(this),
        cellStyle: (params: any) => {
          switch (params.value) {
            case 'Live':
              return { backgroundColor: 'green', color: 'white', fontWeight: 'bold' };
            case 'Active':
              return { backgroundColor: 'yellow', color: 'black', fontWeight: 'bold' };
            case 'InActive':
              return { backgroundColor: 'red', color: 'white', fontWeight: 'bold' };
            default:
              return {};
          }
        }
        // valueFormatter: params => this.datePipe.transform(params.value, 'dd-MM-yyyy') || ''
      },
      {
        headerName: 'Earliest Schedule',
        field: 'Earlier_Schedule',
        headerValueGetter: this.localizeHeader.bind(this),
        valueFormatter: params => this.datePipe.transform(params.value, 'dd-MM-yyyy') || ''
      },
      {
        headerName: 'Technician *',
        field: 'Technician',
        editable: true,
        maxWidth: 250,
        headerValueGetter: this.localizeHeader.bind(this),
        cellEditorFramework: TechnicianDropdownCellEditorComponent,
        cellEditorParams: {
          technicianList: this.technicianList
        },
        cellStyle: (params: any) => {
          return { backgroundColor: '#d8d4d4', };
        },
        valueFormatter: (params) => {
          if (!params.value) return '';

          const ids = params.value.split(',').map((id: string) => id.trim());

          const names = ids.map(id => {
            const tech = this.technicianList.find(t => t.employeeCode === id);
            return tech ? tech.fullName : id;
          });

          return names.join(', ');
        },
        valueSetter: (params) => {
          params.data.Technician = params.newValue;
          return true;
        }
      },

      {
        headerName: 'From Task Date *',
        field: 'StartDate',
        headerValueGetter: this.localizeHeader.bind(this),
        editable: (params) => {
          if (params.data._startDateInitiallyEnabled === undefined) {
            const value = params.data.StartDate || params.value;
            const cellDate = value ? moment(value, moment.ISO_8601, true).startOf('day') : null;
            const today = moment().startOf('day');
            const endDate = params.data.EndDate ? moment(params.data.EndDate, moment.ISO_8601, true).startOf('day') : null;

            const isEndDateInPast = endDate ? endDate.isBefore(today) : false;
            const initiallyEditable = cellDate ? cellDate.isAfter(today) || isEndDateInPast : true;

            params.data._startDateInitiallyEnabled = initiallyEditable;
          }

          return params.data._startDateInitiallyEnabled;
        },


        minWidth: 250,
        cellStyle: (params: any) => {
          return { backgroundColor: '#d8d4d4', };
        },
        cellRenderer: (params) => {
          return params.value ? moment(params.value).format('DD-MM-YYYY') : '';
        },
        cellEditorFramework: DatePickerFromCellEditorComponent,
        cellEditorParams: (params) => {
          if (params.data._startDateInitiallyEnabled === undefined) {
            const cellDate = params.value ? moment(params.value, 'YYYY-MM-DD').startOf('day') : null;
            const today = moment().startOf('day');
            const endDate = params.data.EndDate ? moment(params.data.EndDate, 'YYYY-MM-DD').startOf('day') : null;

            const isEndDateInPast = endDate ? endDate.isBefore(today) : false;
            const initiallyEnabled = cellDate ? cellDate.isAfter(today) || isEndDateInPast : true;

            params.data._startDateInitiallyEnabled = initiallyEnabled;
          }

          return {
            disabled: !params.data._startDateInitiallyEnabled
          };
        },
        valueFormatter: (params) => {
          return params.value ? moment(params.value).format('DD-MM-YYYY') : '';
        },
        valueSetter: (params) => {
          params.data.StartDate = params.newValue
            ? moment(params.newValue).format('YYYY-MM-DD')
            : null;
          params.data.rescheduledFromDate = params.data.StartDate;
          return true;
        },
      },
      {
        headerName: 'To Task Date *',
        field: 'EndDate',
        headerValueGetter: this.localizeHeader.bind(this),
        editable: true,
        minWidth: 250,
        cellStyle: (params: any) => {
          return { backgroundColor: '#d8d4d4', };
        },
        cellRenderer: (params) => {
          return params.value ? moment(params.value).format('DD-MM-YYYY') : '';
        },
        cellEditorFramework: DatePickerCellEditorComponent,
        valueFormatter: (params) => {
          return params.value ? moment(params.value).format('DD-MM-YYYY') : '';
        },
        valueSetter: (params) => {
          params.data.EndDate = params.newValue
            ? moment(params.newValue).format('YYYY-MM-DD')
            : null;
          params.data.rescheduledToDate = params.data.EndDate; // Store separately
          return true;
        },
      },

    ];
  }

  ngOnInit(): void {
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.userSession = this.baseApi.getUserSession();
    this.filteredTechnicianList = [...this.technicianList];
    // Sort tasks by ID in ascending order
    const sortedTasks = [...this.tasks].sort((a, b) => a.ID - b.ID);
    this.getLangWords();

    this.rowData = sortedTasks.map(task => {
      this.originalTechnicianMap[task.ID] = task.Technician;
      return {
        ...task,
        rescheduledFromDate: task.StartDate,
        rescheduledToDate: task.EndDate,
        Technician: task.Technician,
        originalEndDate: task.EndDate,
      };
    });
    this.initialRowData = this.rowData;
    this.latestEndDate();

    sortedTasks.forEach((task, index) => {
      this.getTechAvailableTime(task, index);
    });

    if (this.gridApi) {
      this.updateGridData();
    }
  }
  onDropdownOpened() {
    // Reset filtered list every time dropdown opens
    this.filteredTechnicianList = [...this.technicianList];
    this.technicianSearch = ''; // Clear search input
  }
  searchValues(event: any) {
    const filter = event.target.value.toLowerCase();
    this.filteredTechnicianList = this.technicianList.filter(tech =>
      tech.fullName.toLowerCase().includes(filter));
    this.technicianSearch
  }

  onFromTaskDateChange() {
    const fromTaskDate = this.FromTaskDate?._d;
    const currentDate = new Date();

    if (!fromTaskDate) return;
    if (this.FromTaskDate && this.ToTaskDate && this.FromTaskDate?._d > this.ToTaskDate?._d) {
      this.toaster.warning('To Task Date must be greater than or equal to From Task Date');
      this.ToTaskDate = null;
      return;
    }
    const invalidTask = this.initialRowData.find(row => {
      const startDate = row.StartDate ? new Date(row.StartDate) : null;
      const endDate = row.EndDate ? new Date(row.EndDate) : null;

      const canUpdateDates =
        (!startDate || startDate >= currentDate) || // StartDate is in future or not set
        (endDate && endDate < currentDate);         // EndDate has passed

      return !canUpdateDates;
    });

    if (invalidTask) {
      this.toaster.warning(`From Task Date cannot be changed: From Date is in the past or End Date is still in the future.`);
      this.FromTaskDate = null; // Reset the FromTaskDate
      this.ToTaskDate = null; // Reset ToTaskDate as well
      return;
    }

    // ✅ Valid — update StartDate
    this.rowData = this.rowData.map(row => ({
      ...row,
      StartDate: fromTaskDate,
      rescheduledFromDate: fromTaskDate,
    }));

    this.updateGridData();
  }
  onToTaskDateChange() {
    const toTaskDate = this.ToTaskDate?._d;
    if (!toTaskDate) return;
    if (this.FromTaskDate && this.ToTaskDate && this.FromTaskDate?._d > this.ToTaskDate?._d) {
      this.toaster.warning('To Task Date must be greater than or equal to From Task Date');
      this.ToTaskDate = null;
      return;
    }

    // ✅ Valid — update EndDate
    this.rowData = this.rowData.map(row => ({
      ...row,
      EndDate: toTaskDate,
      rescheduledToDate: toTaskDate,
    }));

    this.updateGridData();
  }


  onCellValueChanged(event: any) {
    console.log('onCellValueChanged: Event=', event);
    if (event.colDef.headerName === 'Technician' && event.newValue !== event.oldValue) {
      const rowIndex = event.rowIndex;
      const task = event.data;
      console.log('Technician changed for task=', task.ID, 'new technician=', event.newValue);

      // Update task data
      task.TaskBy = event.newValue;
      task.TechnicianName = this.technicianList.find(t => t.employeeCode === event.newValue)?.fullName || '';

      // Reset available dates and rescheduled date for this row
      this.availableDateList[rowIndex] = [];
      task.rescheduledDate = null;

      // Fetch new available dates for the updated technician
      this.getTechAvailableTime(task, rowIndex);

      // Update row data
      this.rowData[rowIndex] = { ...task };
      this.updateGridData();
    }
  }
  onTechniciansSelected(selectedTechIds: string[]) {
    if (!selectedTechIds || selectedTechIds.length === 0) {
      // Revert to original technician values
      this.rowData = this.rowData.map(row => ({
        ...row,
        Technician: this.originalTechnicianMap[row.ID] || '',
        TaskBy: this.originalTechnicianMap[row.ID] || ''
      }));

      this.updateGridData();

      // Optionally refetch availability
      this.rowData.forEach((task, index) => {
        this.getTechAvailableTime(task, index);
      });

      return;
    }

    // Apply selected technician IDs to all rows
    const techIdString = selectedTechIds.join(',');

    this.rowData = this.rowData.map(row => ({
      ...row,
      Technician: techIdString,
      TaskBy: techIdString
    }));

    this.updateGridData();

    this.rowData.forEach((task, index) => {
      this.getTechAvailableTime(task, index);
    });
  }
  cellClicked(event: any) {
    console.log('cellClicked: Event=', event);
  }
  onGridReady(params: any) {
    console.log('onGridReady: Grid initialized');
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setRowData(this.rowData);
    this.autoSizeAllColumns();
    console.log('onGridReady: Row count=', this.gridApi.getDisplayedRowCount());
  }

  autoSizeAllColumns() {
    this.gridApi.setRowData(this.rowData);
    this.gridColumnApi.autoSizeAllColumns();
  }

  getTechAvailableTime(task: any, index: number) {
    console.log('getTechAvailableTime: Task month=', task.month);
    const currentDate = new Date();
    let monthIndex = this.monthNames.findIndex(mnth => mnth === task.month);
    if (monthIndex === -1) {
      console.warn(`Invalid month '${task.month}' for task ${task.ID}, defaulting to current month`);
      monthIndex = currentDate.getMonth();
    }
    const day = currentDate.getMonth() === monthIndex ? currentDate.getDate() : 1;
    const year = currentDate.getFullYear();

    const requestDate = new Date(year, monthIndex, day);
    if (isNaN(requestDate.getTime())) {
      console.error(`Invalid date constructed: ${monthIndex + 1}-${day}-${year}`);
      return;
    }

    const data = {
      id: task.Task.ID,
      taskId: task.ID,
      techId: task.TaskBy,
      taskDuration: task.Task.Duration,
      date: requestDate,
    };

    console.log('getTechAvailableTime: Fetching for task=', task.ID, 'with data=', data);
    this.spinnerText = 'Fetching Available Time';
    this.spinner.show();
    this.prevTaskService.getTechAvailableTime(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        console.log('getTechAvailableTime: Response=', res);
        if (res.status) {
          // Filter dates with available hours > 0
          this.availableDateList[index] = res.data
            .filter((d: any) => d.availableHrs > 0)
            .map((d: any) => d.date);
          console.log(`Available dates for task ${task.ID} at index ${index}:`, this.availableDateList[index]);

          // Update the row data to ensure the grid reflects the latest state
          this.rowData[index] = { ...this.rowData[index] };
          this.updateGridData();
        } else {
          this.toaster.error(res.message || 'Failed to fetch available times', 'Error');
          this.availableDateList[index] = [];
          this.updateGridData();
        }
      },
      (err: any) => {
        this.spinner.hide();
        this.toaster.error(err?.ErrorMessage || 'Error fetching available times', 'Error');
        console.error('getTechAvailableTime: Error=', err);
        this.availableDateList[index] = [];
        this.updateGridData();
      }
    );
  }

  updateGridData() {
    if (this.gridApi) {
      console.log('updateGridData: Updating grid with rowData=', this.rowData);
      this.gridApi.setRowData(this.rowData);
      this.gridApi.refreshCells({ force: true });
      this.autoSizeAllColumns();
    } else {
      console.warn('updateGridData: Grid API not yet available');
    }
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onSaveClick() {
    // Validate rescheduled dates
    if (this.rowData.some(task => !task.Technician || !task.rescheduledFromDate || !task.rescheduledToDate)) {
      this.toaster.warning('Please select Start,End dates and Technician for all tasks');
      return;
    }

    const rescheduleData = this.rowData.map(task => ({
      TaskId: task.ID,
      TechnicianId: task.Technician,
      StartDate: moment(task.rescheduledFromDate).format('YYYY-MM-DD'),
      EndDate: moment(task.rescheduledToDate).format('YYYY-MM-DD'),
      CreatedBy: this.userSession?.userCode
    }));

    console.log('onSaveClick: Sending payload =', rescheduleData); // Debug payload

    this.spinnerText = 'Rescheduling Tasks...';
    this.spinner.show();

    this.prevTaskService.resheduleTaskList(rescheduleData).subscribe(
      (res: any) => {
        this.spinner.hide();
        console.log('reschedule response: ', res);
        this.toaster.success(res.message || 'Tasks rescheduled successfully', 'Success');
        this.dialogRef.close({
          success: true,
          updatedTasks: rescheduleData,
        });
      },
      (err: any) => {
        this.spinner.hide();
        this.toaster.error(err?.ErrorMessage || 'Server error occurred', 'Error');
      }
    );
  }

  latestEndDate(): Date | null {
    const validDates = this.rowData
      .map(row => row.EndDate ? new Date(row.EndDate) : null)
      .filter(date => date !== null);

    if (validDates.length === 0) return null;

    this.toTaskMinDate = new Date(validDates.reduce((latest, current) => current > latest ? current : latest, new Date(0)));
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find(x => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi.refreshHeader();
      }
    });
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.headerName;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }


}